module.exports = __webpack_public_path__ + "static/media/beach.311b4caf.jpg";